import React from "react";
import { Link } from "react-router-dom";
import { LockOutlined, RightOutlined } from "@ant-design/icons";
import Loader from "../../../../components/Loading/Loader";

const TalentSection = ({
  iconEmoji,
  iconClass,
  titleText,
  count,
  loading = false,
  showViewAll = false,
  viewAllHref,
  onViewAll,
  locked = false,
  lockedTitle = "",
  lockedDescription = "",
  lockedActionLabel = "",
  onLockedAction,
  children,
  showHeader = true,
}) => {
  const viewAllButton = showViewAll ? (
    <button
      className="qp-view-all"
      type="button"
      onClick={onViewAll}
      disabled={locked}
    >
      View All <RightOutlined style={{ fontSize: 12 }} />
    </button>
  ) : null;

  return (
  <div className="qp-section">
    <div className="qp-section-header">
      {showHeader && <div className="qp-section-title">
        <div className={`qp-section-icon ${iconClass}`}>{iconEmoji}</div>
        {titleText} ({count})
      </div>}
      {viewAllButton && (viewAllHref && !locked ? (
        <Link
          to={viewAllHref}
          style={{ display: "contents", textDecoration: "none", color: "inherit" }}
        >
          {viewAllButton}
        </Link>
      ) : viewAllButton)}
    </div>
    <div className={`qp-section-body ${locked ? "qp-section-body-locked" : ""}`}>
      {loading ? (
        <div className="qp-section-loader">
          <Loader backgroundColor="transparent" />
        </div>
      ) : (
        <div className="qp-cards-grid">{children}</div>
      )}

      {locked && !loading ? (
        <div className="qp-section-lock-overlay">
          <div className="qp-section-lock-card">
            <h3 className="qp-section-lock-title">{lockedTitle}</h3>
            <p className="qp-section-lock-description">{lockedDescription}</p>
            <button
              className="qp-section-lock-button"
              type="button"
              onClick={onLockedAction}
            >
              <LockOutlined />
              <span>{lockedActionLabel}</span>
            </button>
          </div>
        </div>
      ) : null}
    </div>
  </div>
  );
};

export default TalentSection;